export const sekilasData = [
	{
		id: 13,
		title: 'Pendataan Email UB yang Terkendala',
		link: '/abhiyaksa-info/pendataan-email-ub-yang-terkendala',
		desc: '',
		bg: 'bg-email-bg',
	},
	{
		id: 12,
		title: 'Laporan Pelecehan Seksual',
		link: '/abhiyaksa-info/laporan-pelecehan-seksual',
		desc: '',
		bg: 'bg-panduan-bg',
	},
	{
		id: 10,
		title: 'Informasi Virtual Background',
		link: '/abhiyaksa-info/info-vbg',
		desc: '',
		bg: 'bg-vbg-bg',
	},
	{
		id: 11,
		title: 'Informasi Kesalahan Enroll Classroom',
		link: '/abhiyaksa-info/info-kesalahan-enroll',
		desc: '',
		bg: 'bg-enroll-bg',
	},
	{
		id: 9,
		title: 'Informasi Pelaksanaan Rangkaian',
		link: '/abhiyaksa-info/info-rangkaian',
		desc: '',
		bg: 'bg-rangkaian-bg',
	},
	{
		id: 7,
		title: 'Informasi Pertanyaan PKKMB',
		link: '/abhiyaksa-info/info-pertanyaan',
		desc: '',
		bg: 'bg-halo-bg',
	},
	{
		id: 8,
		title: 'Informasi PKKMB Fakultas',
		link: '/abhiyaksa-info/info-pkkmb-fakultas',
		desc: '',
		bg: 'bg-ospekFak-bg',
	},
	{
		id: 2,
		title: 'Apa itu RAJA Brawijaya',
		link: '',
		desc: 'RAJA Brawijaya atau Rangkaian Acara Jelajah Almamater Universitas Brawijaya adalah serangkaian kegiatan yang bertujuan untuk memfasilitasi mahasiswa baru Universitas Brawijaya agar dapat mengetahui hal-hal yang terkait dengan kehidupan kampus. Rangkaian ini sendiri terdiri dari tiga rangkaian yaitu PKKMB, PBPK, dan OH.',
		bg: 'bg-apaitu-bg',
	},
	{
		id: 3,
		title: 'Rasanya Jadi Anak UB',
		link: 'https://www.youtube.com/embed/vDoq1VY25K0',
		desc: '',
		bg: 'bg-podcast-bg',
	},
	{
		id: 4,
		title: 'Jingle RAJA Brawijaya',
		link: 'https://www.youtube.com/embed/eiHfJXQSnkY',
		desc: '',
		bg: 'bg-jingle-bg',
	},
	{
		id: 6,
		title: 'Panduan PKKMB 2021',
		link: '/abhiyaksa-info/panduan-pkkmb',
		desc: '',
		bg: 'bg-kbgo-bg',
	},

	{
		id: 1,
		title: 'Informasi Twibbon',
		link: '/abhiyaksa-info/info-twibbon',
		desc: '',
		bg: 'bg-twibbon-bg',
	},

	{
		id: 5,
		title: 'Informasi Atribut',
		link: '/abhiyaksa-info/info-atribut',
		desc: '',
		bg: 'bg-atribut-bg',
	},
];
